import { API, graphqlOperation } from "aws-amplify";
import { useEffect } from "react";
import { useState } from "react";
import { getCompany } from "../../graphql/queries";
import { Avatar, Box, CircularProgress, Typography } from "@mui/material";
// import 'driver.js/dist/driver.css';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useThemes } from "../Theme/theme";
import useControlledNavigation from "../../hooks/useControlledNavigation";

let updateAPI = null;

export const DoughnutChartComponent = () => {
  const { theme } = useThemes();

  const navigate = useControlledNavigation();
  const [percentage, setPercentage] = useState(0);
  const [cirPercentage, setCPercentage] = useState(0);
  const [hover, setHover] = useState(true);

  const data = {
    datasets: [
      {
        data: [percentage, 100 - percentage],
        backgroundColor: [theme.palette.primary.main, "#BDBDBD"], // Green for the percentage, gray for the rest
      },
    ],
  };

  const options = {
    responsive: false,
    maintainAspectRatio: true,
    legend: {
      display: false,
      position: "bottom",
    },
    tooltips: {
      enabled: false,
    },
    cutoutPercentage: 100,
    animation: {
      animateScale: false,
      animateRotate: true,
    },
  };
  const dataCk = useSelector((state) => state?.companyReducer.companyDetails);
  const companyLoaded = useSelector((state) => state?.companyReducer.Loaded);
  let logo1 = dataCk?.relatedcompanydetailsnew?.[0]?.companylogourl;

  console.log(logo1, "logo");
  async function getCompanyDetails() {
    let arr1 = [];
    let arr2 = [];
    let relatedPhoneContacts = 0;
    let relatedEmailContacts = 0;
    let relatedCompanyEntity = 0;
    let relatedAddressEntity = 0;
    let per = 0;
    let count = 1;
    let compID = localStorage.getItem("companyID");
    try {
      let notArr = [
        "StatusCode",
        "StatusMessage",
        "EnteredTimeStamp",
        "ExpiredTimeStamp",
        "LastUpdatedBy",
        "__typename",
      ];
      // const res = await API.graphql(graphqlOperation(getCompany));
      // let dataCk = res?.data?.getCompany
      let logo1 = dataCk?.relatedcompanydetailsnew[0]?.companylogourl;
      arr1 = [...arr1, dataCk?.companyname !== "" ? dataCk?.companyname : arr1];
      arr1 = [...arr1, logo1 !== "" ? logo1 : arr1];

      // if (dataCk?.relatedAddressEntity?.length !== 0) {
      //   let a = dataCk.relatedAddressEntity[0];

      //   const keysToExtract = [
      //     "City",
      //     "CountryCode",
      //     "District",
      //     "Line1",
      //     "PINCode",
      //     "StateCode",
      //   ];

      //   const extractedObject = keysToExtract.reduce((acc, key) => {
      //     if (a.hasOwnProperty(key)) {
      //       acc[key] = a[key];
      //     }
      //     return acc;
      //   }, {});
      //   console.log(extractedObject, "extractedObject");
      //   const truthyValuesObject = Object.entries(extractedObject)
      //     .filter(([key, value]) => Boolean(value))
      //     .reduce((acc, [key, value]) => {
      //       acc[key] = value;
      //       return acc;
      //     }, {});
      //   console.log(truthyValuesObject.length, "truthyValuesObject");
      //   relatedAddressEntity = Object.values(truthyValuesObject).length * 10;
      //   console.log(relatedAddressEntity, "relatedAddressEntity");
      //   for (let key in a) {
      //     if (!notArr.includes(key)) {
      //       count++;
      //       arr2 = [...arr2, a[key]];
      //       if (a[key]?.toString().split("*").join("").length !== 0) {
      //         arr1.push(a[key]?.toString().split("*").join(""));
      //       }
      //     }
      //   }
      // }

      // if (dataCk?.relatedCompanyDetailsNew?.length !== 0) {
      //   let a = dataCk.relatedCompanyDetailsNew[0];
      //   console.log(a, "arelatedCompanyDetailsNew");
      //   for (let key in a) {
      //     if (!notArr.includes(key)) {
      //       count++;
      //       arr2 = [...arr2, a[key]];
      //       if (a[key]?.toString().split("*").join("").length !== 0) {
      //         arr1.push(a[key]?.toString().split("*").join(""));
      //       }
      //     }
      //   }
      // }

      // if (dataCk?.relatedCompanyEntity?.length !== 0) {
      //   let a = dataCk.relatedCompanyEntity[0];
      //   console.log(a, "relatedCompanyEntity");
      //   relatedCompanyEntity = a.CompanyEntityType ? 10 : 0;
      //   for (let key in a) {
      //     if (!notArr.includes(key)) {
      //       count++;
      //       arr2 = [...arr2, a[key]];
      //       if (a[key]?.toString().split("*").join("").length !== 0) {
      //         arr1.push(a[key]?.toString().split("*").join(""));
      //       }
      //     }
      //   }
      // }

      // if (dataCk?.relatedEmailContacts?.length !== 0) {
      //   let a = dataCk.relatedEmailContacts[0];
      //   console.log(a, "relatedEmailContacts");
      //   relatedEmailContacts = a.EmailAddress ? 10 : 0;
      //   for (let key in a) {
      //     if (!notArr.includes(key)) {
      //       count++;
      //       arr2 = [...arr2, a[key]];
      //       if (a[key]?.toString().split("*").join("").length !== 0) {
      //         arr1.push(a[key]?.toString().split("*").join(""));
      //       }
      //     }
      //   }
      // }

      // if (dataCk?.relatedPhoneContacts?.length !== 0) {
      //   let a = dataCk.relatedPhoneContacts[0];
      //   console.log(a, "relatedPhoneContacts");
      //   relatedPhoneContacts = a.PhoneNumber ? 10 : 0;
      //   for (let key in a) {
      //     // console.log(a,);
      //     if (!notArr.includes(key)) {
      //       count++;
      //       arr2 = [...arr2, a[key]];
      //       if (a[key]?.toString().split("*").join("").length !== 0) {
      //         arr1.push(a[key]?.toString().split("*").join(""));
      //       }
      //     }
      //   }
      // }
      // let per =
      //   relatedPhoneContacts +
      //   relatedAddressEntity +
      //   relatedEmailContacts +
      //   relatedPhoneContacts +
      //   relatedCompanyEntity;
      // setPercentage(per);
      // if (dataCk?.CompanyName === "") {
      //   setPercentage(15);
      // } else {
      //   if ((arr1.length / count) * 100 < 25) {
      //     setPercentage(20);
      //   }
      // }
    } catch {
      console.log("error");
    }
  }
  updateAPI = { update: getCompanyDetails };
  useEffect(() => {
    if (companyLoaded) {
      getCompanyDetails();
    }
  }, [companyLoaded]);

  if (cirPercentage <= percentage) {
    let add = percentage / 50;
    setTimeout(() => {
      setCPercentage(cirPercentage + add);
    }, 50);
  }
  return (
    <div >
      {/* <Doughnut id="123" style={{ height: "55px" }} data={data} options={options} /> */}
      <Box >
        {/* <Box sx={{ height: "15px", background: "#BDBDBD", borderRadius: "5px 2px 2px 5px" }}>
                    <Box sx={{ width: `${percentage}%`, height: "15px", background: "#72378D", borderRadius: "5px", transition: 'width 3.6s', }} />
                </Box>
                <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    fontSize={"15px"}
                    // fontWeight='550'
                    sx={{
                        fontSize: "10px",
                        display: { xs: "none", md: "block" },
                        // marginLeft: "30px",
                        textTransform: "capitalize",
                        // color : "#396afc",
                        color: "nav.font",
                        fontWeight: "bold",
                    }}
                >
                    {Math.round(percentage)}% of your profile is completed
                </Typography> */}

        <div
          style={{
            position: "relative",
            // display: "inline-block",
            width: "50px",
            marginRight: "2px",
            display: "flex",
            alignItems: "center",
          }}
           
        >
          <Box
            className="step-1"
            sx={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // marginRight: 2,
            }}
            // onMouseEnter={() => {
            //   setHover(false);
            // }}
            // onMouseLeave={() => {
            //   setHover(true);
            // }}
          >
            <Avatar
              // alt={companyDetails?.getCompany?.relatedCompanyDetailsNew[0]?.CompanyLogoUrl}
              // src={hover ? logo : ""}
              src={logo1}
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                border: "1px solid",
                img: { objectFit: "contain" },
              }}
              
            >
              {/* <Typography
                variant="h6"
                noWrap
                component="div"
                fontSize={"15px"}
                // fontWeight='550'
                sx={{
                  width: "100%",
                  height: "100%",
                  fontSize: "11px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // marginLeft: "30px",
                  textTransform: "capitalize",
                  // color : "#396afc",
                  color: "nav.font",
                  fontWeight: "bold",
                }}
              >
                {Math.round(percentage)}%
              </Typography> */}
            </Avatar>

            {/* <CircularProgress
              variant="determinate"
              value={cirPercentage}
              // size={100}
              thickness={3}
              style={{
                position: "absolute",
                // top: 0,
                // left: 0,
                width: "48px",
                height: "48px",
                color: "blue",
                transform: "rotate(245deg)",
              }}
            /> */}
          </Box>
        </div>
      </Box>
    </div>
  );
};

export function updateAPINAV() {
  if (updateAPI != null) {
    updateAPI.update();
  }
}
